module.exports = __webpack_public_path__ + "static/media/icon_ocultar.f0cad6b6.svg";